import { render, staticRenderFns } from "./online_quitting.vue?vue&type=template&id=6bb3fccf&scoped=true"
import script from "./online_quitting.vue?vue&type=script&lang=js"
export * from "./online_quitting.vue?vue&type=script&lang=js"
import style0 from "./online_quitting.vue?vue&type=style&index=0&id=6bb3fccf&prod&scoped=true&lang=less"
import style1 from "./online_quitting.vue?vue&type=style&index=1&id=6bb3fccf&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb3fccf",
  null
  
)

export default component.exports